module.exports = __webpack_public_path__ + "img/menu-account-icon.bd5c63fe.svg";